import {Breakpoints, ChevronLeft, ChevronRight} from '@vw-marketing/us-components';
import React, {ReactElement} from 'react';
import Slider from 'react-slick';
import {FeatureAppTrackingManager} from '../../hooks/use-tracking-manager';
import {useViewport, ViewportType} from '../../hooks/use-viewport';
import {onVWBasicLinkClickEvent} from '../../tagging/tagging-helpers';
import {StyledFilterSlickContainer, StyledSlickArrow} from './styles';

export type viewportType = 'desktop' | 'tablet' | 'mobile';

interface FilterAppliedSlickProps {
  children: ReactElement[];
  trackingManager: FeatureAppTrackingManager;
}

interface FilterArrowProps {
  onClick?: () => void;
  type: 'left' | 'right';
  className?: string;
  trackingManager: FeatureAppTrackingManager;
}
const FilterArrow: React.FC<FilterArrowProps> = (props) => {
  const {onClick, type, className, trackingManager} = props;
  const Arrow = type === 'left' ? ChevronLeft : ChevronRight;

  const onHandleArrowClick = () => {
    onClick && onClick();

    // Tagging section
    trackingManager &&
      onVWBasicLinkClickEvent(trackingManager, 'Results Filters', {
        url: `go to ${type}`,
        name: 'click',
        newTab: false,
      });
  };
  return (
    <StyledSlickArrow onClick={onHandleArrowClick} className={className}>
      <div className={`arrow-${type}`}>
        <Arrow variant="small" />
      </div>
    </StyledSlickArrow>
  );
};

const getCardToShow = (viewport: viewportType) => {
  switch (viewport) {
    case ViewportType.MOBILE:
      return 1;
    case ViewportType.TABLET:
      return 1;
    case ViewportType.DESKTOP:
      return 4;
    default:
      return 1;
  }
};
const FilterAppliedSlick: React.FC<FilterAppliedSlickProps> = (props) => {
  const {children, trackingManager} = props;
  const [sliderRef, setSliderRef] = React.useState<Slider | null>();
  const [cardsToShow, setCardsToShow] = React.useState(1);
  const viewport = useViewport(Breakpoints.b560, Breakpoints.b1280);
  React.useEffect(() => {
    setCardsToShow(getCardToShow(viewport));
    return () => {};
  }, [viewport]);

  const settings = {
    dots: false,
    arrows: true,
    infinite: false,
    centerMode: false,
    speed: 500,
    slidesToShow: cardsToShow,
    slidesToScroll: 1,
    initialSlide: 0,
    variableWidth: true,
    nextArrow: <FilterArrow type="right" trackingManager={trackingManager} />,
    prevArrow: <FilterArrow type="left" trackingManager={trackingManager} />,
  };

  React.useEffect(() => {
    // Initializes slider index when child changes
    sliderRef?.slickGoTo(0);
    return () => {};
  }, [children]);

  return (
    <StyledFilterSlickContainer
      className="filter-slick-wrapper"
      oneChildren={children.length === 1}
    >
      <Slider {...settings} ref={(slider: Slider) => setSliderRef(slider)}>
        {children?.map((child: React.ReactElement) =>
          React.cloneElement(child),
        )}
      </Slider>
    </StyledFilterSlickContainer>
  );
};

export default FilterAppliedSlick;
